<div class="seed-return-add-prod" (window:resize)="onresize($event)">
  <div class="prod-top-sec">
    <h3 class="xs-pl-0">
      Add Product(s) to the Return
    </h3>

    <div class="form-sec">
      <div class="row margin-r0">
        <div class="col-md-12 col-lg-12 smallPadRgt0">
          <app-seedreturnfilter [filters]="filterTypeList" (SearchFilter)="filterProductGridData($event)" (ClearFilter)="filterProductGridData($event)"></app-seedreturnfilter>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12 tabBgColor padding-t20">
      <mat-tab-group disableRipple [animationDuration]="'400ms'" class="matTabs prepayLandingTab" (selectedTabChange)="tabChanged($event)">
        <mat-tab>

          <ng-template mat-tab-label>
            <div class="tab-head" id="divAccountTab">
              <h4>
                Your Account Invoiced Products
              </h4>
              <span *ngIf="!isReturnTypeForInnoculant" class="non-return-prod">
                Show Non-Returnable Product <mat-checkbox (change)="showShipToNonReturnableProducts(!isShipToNonReturnable)" class="custom-checkbox margin-l10"></mat-checkbox>
              </span>
            </div>
          </ng-template>

          <div class="tableContainer prodTableContainer accInvProdTable">
            <table mat-table [dataSource]="productAllDataSource" multiTemplateDataRows class="matTables productTable">
              <ng-container matColumnDef="Product Name">
                <th mat-header-cell *matHeaderCellDef class="productNameBlock">Product Name </th>
                <td mat-cell *matCellDef="let element" class="order-info cursor-defualt" id="td-ProductName">
                  <p> {{element.itemVendorName}}</p>
                  <p class="grower-name">
                    {{element.itemDescription}}
                  </p>
                </td>
              </ng-container>

              <!-- Weight Column -->
              <ng-container matColumnDef="Eligible Units">
                <th mat-header-cell *matHeaderCellDef class="text-center eligibleUnits"> Eligible Units </th>
                <td mat-cell *matCellDef="let element" class="text-center">
                  <span *ngIf="element.displayMessage==null"> {{element.invoiceUnits - element.totalReturnUnits > 0 ? element.invoiceUnits - element.totalReturnUnits : 0}} </span>
                </td>
              </ng-container>
              <ng-container matColumnDef="Pack Size">
                <th mat-header-cell *matHeaderCellDef class="text-center packSize"> Pack Size </th>
                <td mat-cell *matCellDef="let element" class="text-center">
                  <span> {{element.packageSizeDesc}} </span>
                </td>
              </ng-container>
              <ng-container matColumnDef="Seed Size">
                <th mat-header-cell *matHeaderCellDef class="text-center seedSize"> Seed Size </th>
                <td mat-cell *matCellDef="let element" class="text-center">
                  <span> {{element.seedSize}} </span>
                </td>
              </ng-container>
              <ng-container matColumnDef="Technology">
                <th mat-header-cell *matHeaderCellDef class="text-center technology"> Technology </th>
                <td mat-cell *matCellDef="let element" class="text-center">
                  <span class="oval-shape" [ngClass]="{'technology': (element.highlightTechnology===1)}" matTooltip="{{element.technology}}" [matTooltipPosition]="'above'">
                    {{element.technology}}
                  </span>
                </td>
              </ng-container>
              <ng-container matColumnDef="Treatment">
                <th mat-header-cell *matHeaderCellDef class="text-center treatment"> Treatment </th>
                <td mat-cell *matCellDef="let element" class="text-center">
                  <span>
                    {{element.treatmentDescription}}
                  </span>
                </td>
              </ng-container>
              <ng-container matColumnDef="Product Line">
                <th mat-header-cell *matHeaderCellDef class="text-center prodLine">  Product Line </th>
                <td mat-cell *matCellDef="let element" class="text-center product-line">
                  <span>
                    {{element.productLine}}
                  </span>
                  <div class="" *ngIf="isReturnTypeForInnoculant">
                    <div class="checkBoxOuterBg">
                      <div class="chkboxOuter">
                        <i class="fas fa-check checkShowHide"></i>
                        <mat-checkbox class="custom-checkbox select-all-check hide" [ngModel]="element.IsProductSelected" *ngIf="element.IsProductSelected && element.displayMessage==null"></mat-checkbox>
                      </div>
                    </div>
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="LotNumber" *ngIf="!isReturnTypeForInnoculant">
                <th mat-header-cell *matHeaderCellDef class="text-center lotNo">Lot # </th>
                <td mat-cell *matCellDef="let element" class="product-line text-center">
                  <div class="checkBoxOuterBg">
                    <div class="chkboxOuter">
                      <i class="fas fa-check checkShowHide"></i>
                      <mat-checkbox class="custom-checkbox select-all-check hide" [ngModel]="element.IsProductSelected" *ngIf="element.IsProductSelected && element.displayMessage==null"></mat-checkbox>
                    </div>
                  </div>
                  <span *ngIf="element.displayMessage==null">
                    {{element.lotNumber}}
                  </span>
                  <div *ngIf="element.displayMessage!=null" class="measureUnit text-center ineligible-return">
                    <p> {{element.displayMessage}} </p>
                  </div>
                </td>
              </ng-container>

              <ng-container matColumnDef="expandedDetail">
                <td mat-cell class="product-details" *matCellDef="let element" [attr.colspan]="displayedColumns.length">
                  <div class="inline-error" *ngIf="element.lineErrors && element.lineErrors.errors.length > 0">
                    <div class="row">
                      <div class="col-md-9">
                        <ol class="error-list">
                          <li *ngFor="let err of element.lineErrors.errors">
                            {{err}}
                        </ol>
                      </div>
                    </div>
                  </div>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true;"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="{'ineligible-row':(row?.displayMessage!=null),'active':(row?.IsProductSelected), 'read-only-row':(row.invoiceUnits - row.totalReturnUnits <= 0)}" (click)="keepRecords(row,true)"></tr>
              <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
            </table>
          </div>
        </mat-tab>
        <mat-tab>

          <ng-template mat-tab-label>
            <div class="tab-head" id="divParentTab">
              <h4>
                Parent Company Invoiced Products
              </h4>
              <span *ngIf="!isReturnTypeForInnoculant" class="non-return-prod">
                Show Non-Returnable Product <mat-checkbox (change)="showParentNonReturnableProducts(!isParentNonReturnable)" class="custom-checkbox margin-l10"></mat-checkbox>
              </span>
            </div>
          </ng-template>

          <div class="tableContainer prodTableContainer compInvProdTable">
            <table mat-table [dataSource]="parentAccountDataSource" multiTemplateDataRows class="matTables productTable">
              <ng-container matColumnDef="Product Name">
                <th mat-header-cell *matHeaderCellDef class="productNameBlock">Product Name </th>
                <td mat-cell *matCellDef="let element" class="order-info" id="td-ProductName">
                  <p> {{element.itemVendorName}}</p>
                  <p class="grower-name">
                    {{element.itemDescription}}
                  </p>
                </td>
              </ng-container>

              <!-- Weight Column -->
              <ng-container matColumnDef="Eligible Units">
                <th mat-header-cell *matHeaderCellDef class="text-center eligibleUnits"> Eligible Units </th>
                <td mat-cell *matCellDef="let element" class="text-center">
                  <span *ngIf="element.displayMessage==null"> {{element.invoiceUnits - element.totalReturnUnits > 0 ? element.invoiceUnits - element.totalReturnUnits : 0}} </span>
                </td>
              </ng-container>
              <ng-container matColumnDef="Pack Size">
                <th mat-header-cell *matHeaderCellDef class="text-center packSize"> Pack Size </th>
                <td mat-cell *matCellDef="let element" class="text-center">
                  <span> {{element.packageSizeDesc}} </span>
                </td>
              </ng-container>
              <ng-container matColumnDef="Seed Size">
                <th mat-header-cell *matHeaderCellDef class="text-center seedSize"> Seed Size </th>
                <td mat-cell *matCellDef="let element" class="text-center">
                  <span> {{element.seedSize}} </span>
                </td>
              </ng-container>
              <ng-container matColumnDef="Technology">
                <th mat-header-cell *matHeaderCellDef class="text-center technology"> Technology </th>
                <td mat-cell *matCellDef="let element" class="text-center">
                  <span class="oval-shape" [ngClass]="{'technology': (element.highlightTechnology===1)}" matTooltip="{{element.technology}}" [matTooltipPosition]="'above'">
                    {{element.technology}}
                  </span>
                </td>
              </ng-container>
              <ng-container matColumnDef="Treatment">
                <th mat-header-cell *matHeaderCellDef class="text-center treatment"> Treatment </th>
                <td mat-cell *matCellDef="let element" class="text-center">
                  <span>
                    {{element.treatmentDescription}}
                  </span>
                </td>
              </ng-container>
              <ng-container matColumnDef="Product Line">
                <th mat-header-cell *matHeaderCellDef class="text-center prodLine">  Product Line </th>
                <td mat-cell *matCellDef="let element" class="product-line text-center">
                  <span>
                    {{element.productLine}}
                  </span>
                  <div class="" *ngIf="isReturnTypeForInnoculant">
                    <div class="checkBoxOuterBg">
                      <div class="chkboxOuter">
                        <i class="fas fa-check checkShowHide"></i>
                        <mat-checkbox class="custom-checkbox select-all-check hide" [ngModel]="element.IsProductSelected" *ngIf="element.IsProductSelected && element.displayMessage==null"></mat-checkbox>
                      </div>
                    </div>
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="LotNumber" *ngIf="!isReturnTypeForInnoculant">
                <th mat-header-cell *matHeaderCellDef class="text-center lotNo">Lot # </th>
                <td mat-cell *matCellDef="let element" class="product-line text-center">
                  <div class="checkBoxOuterBg">
                    <div class="chkboxOuter">
                      <i class="fas fa-check checkShowHide"></i>
                      <mat-checkbox class="custom-checkbox select-all-check hide" [ngModel]="element.IsProductSelected" *ngIf="element.IsProductSelected && element.displayMessage==null"></mat-checkbox>
                    </div>
                  </div>
                  <span *ngIf="element.displayMessage==null">
                    {{element.lotNumber}}
                  </span>
                  <div *ngIf="element.displayMessage!=null" class="measureUnit text-center ineligible-return">
                    <p> {{element.displayMessage}} </p>
                  </div>
                </td>
              </ng-container>

              <ng-container matColumnDef="expandedDetail">
                <td mat-cell class="product-details" *matCellDef="let element" [attr.colspan]="displayedColumns.length">
                  <div class="inline-error" *ngIf="element.lineErrors && element.lineErrors.errors.length > 0">
                    <div class="row">
                      <div class="col-md-9">
                        <ul class="error-list">
                          <li *ngFor="let err of element.lineErrors.errors">
                            {{err}}
                        </ul>
                      </div>
                    </div>
                  </div>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true;"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="{'ineligible-row':(row?.displayMessage!=null),'active':(row?.IsProductSelected), 'read-only-row':(row.invoiceUnits - row.totalReturnUnits <= 0)}" (click)="keepRecords(row,false)"></tr>
              <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
            </table>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
  <div class="row add-order-sec margin-l0 margin-r0">
    <div class="col-md-2 padding-l0">
      <button id="btn-add-to-request" mat-raised-button class="btns wide100" color="primary" [disabled]="isProductNotAdded" (click)="addSelectedProductToOrder()">Add To Request</button>
    </div>
    <div class="col-md-2 padding-l0">
      <button mat-raised-button class="btns wide100" color="primary" [disabled]="isDisableExportButton()" (click)="export()">Export</button>
    </div>
    <div class="col-md-8 text-right">
      <span class="count">Product selected <span>{{selectedProductList.length}} </span></span>
    </div>
  </div>
</div>
